import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { SideRedHeading } from '../components/Headings';
import { HomeDescription } from '../styles';
import EventsTableTabs from './components/Events/EventsTableTabs';

function EventsSection() {
  const lang = useSelector((state) => state?.local?.local);

  return (
    <div className="card bg-white" id="public-events">
      <div className="card-header">
        <SideRedHeading>
          <FormattedMessage id="Events" />
        </SideRedHeading>
        <HomeDescription className="mb-3">
          {lang === 'ne' ? (
            <p>
              PLGSP को समन्वयमा विभिन्न विषयगत क्षेत्रका क्षमता अभिवृद्धि कार्यक्रमहरु संचालन
              भइरहेको छ। इच्छुक व्यक्तिले कार्यक्रममा सहभागिताको निम्ति आवेदन दिन सक्नुहुनेछ।
            </p>
          ) : (
            <p>
              Capacity building programs in various thematic areas are being conducted in
              coordination with PLGSP. Interested personnel can apply for participation in the
              program.
            </p>
          )}
        </HomeDescription>
      </div>
      <div className="card-body">
        <div>
          <EventsTableTabs isHomePage={true} />
        </div>
      </div>
    </div>
  );
}

export default EventsSection;
